import React, { useEffect, useState, useRef, memo } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ClockIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const DealOfTheDay = memo(function DealOfTheDay() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            }
          }
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Premium Protein Powder 5lb',
    brand: 'Optimum Nutrition',
    price: 49.99,
    originalPrice: 89.99,
    discount: 44,
    rating: 4.9,
    reviewCount: 3456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Pre-Workout Energy Boost',
    brand: 'C4',
    price: 29.99,
    originalPrice: 49.99,
    discount: 40,
    rating: 4.7,
    reviewCount: 2103,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'BCAA Recovery Formula',
    brand: 'Scivation',
    price: 34.99,
    originalPrice: 54.99,
    discount: 36,
    rating: 4.8,
    reviewCount: 1789,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Mass Gainer 12lb',
    brand: 'Serious Mass',
    price: 59.99,
    originalPrice: 99.99,
    discount: 40,
    rating: 4.6,
    reviewCount: 1234,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Creatine Monohydrate',
    brand: 'MuscleTech',
    price: 24.99,
    originalPrice: 39.99,
    discount: 38,
    rating: 4.7,
    reviewCount: 987,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Fat Burner Thermogenic',
    brand: 'Hydroxycut',
    price: 39.99,
    originalPrice: 64.99,
    discount: 38,
    rating: 4.5,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="w-full" data-id="element-2163" data-mp="2y74s96b1xx6o">
      <div className="container mx-auto px-4" data-id="element-2164" data-mp="32zppyix2wufh">
        <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-xl overflow-hidden mb-6" data-id="element-2165" data-mp="3310sygip9y5j">
          <div className="p-6 md:p-8" data-id="element-2166" data-mp="37y9aqfzxs069">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2167" data-mp="2ab0j039cduvt">
              <div className="mb-4 md:mb-0" data-id="element-2168" data-mp="2fa3pls4z095w">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2169" data-mp="2fawltz6azg9s">
                  24 HOUR SPECIAL
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2170" data-mp="2obl1eybchoos">
                  <ZapIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2171" data-mp="3vnbqtjex9kyn" />
                  Deal of the Day
                </h2>
              </div>
              <div className="flex items-center gap-4" data-id="element-2172" data-mp="3mnjbzfz66ny">
                <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-full px-4 py-2" data-id="element-2173" data-mp="24ggrgi0pv6o">
                  <ClockIcon className="w-4 h-4 text-white" data-id="element-2174" data-mp="3tb02vrtb17ka" />
                  <div className="flex items-center gap-1 font-mono font-bold text-white" data-id="element-2175" data-mp="c1bhm61rk7o4">
                    <span data-id="element-2176" data-mp="72i2682x26lb">{String(timeLeft.hours).padStart(2, '0')}</span>
                    <span data-id="element-2177" data-mp="74l0dfe83614">:</span>
                    <span data-id="element-2178" data-mp="l1zw11v2ka1j">{String(timeLeft.minutes).padStart(2, '0')}</span>
                    <span data-id="element-2179" data-mp="kzww9q4472jm">:</span>
                    <span data-id="element-2180" data-mp="g3pw6dyegl9l">{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                </div>
                <a href="#" className="hidden md:flex text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors items-center" data-id="element-2181" data-mp="uqrhqs9jdy40">
                  View All
                  <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2182" data-mp="zrfk2a37u1dj" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative" data-id="element-2183" data-mp="1neap9bmxca8j">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2184" data-mp="1nd9g5cpgxxtg">
              {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
            width: 'calc(50% - 6px)'
          }} data-id="element-2185" data-mp="14gzrxwkurqvq">
                  <EnhancedProductCard product={product} data-id="element-2186" data-mp="uniwyp8zc5qh" />
                </div>)}
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-2187" data-mp="lo5nvxorpj6a">
              {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2188" data-mp="2inwhvbw4ls3h" data-mpi={index} />)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2189" data-mp="32bwwdrtq2oqq">
            {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-2190" data-mp="2xb94l3xo63vg" />)}
          </div>}
      </div>
    </div>;
});